function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FaTimes } from 'react-icons/fa';
import ContactUsPopup from './ContactUsPopup.react';
var ContactUsBubble = function ContactUsBubble() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    if (isOpen) handleOnOpen();else handleOnHide();
  }, [isOpen]);
  var handleOnOpen = function handleOnOpen() {
    $('.contact-us-bubble__label').css({
      opacity: 0
    });
    $('.contact-us-bubble').css({
      width: 49
    });
    setTimeout(function () {
      $('.contact-us-bubble__close').css({
        display: 'flex'
      });
      $('.contact-us-bubble__label').css({
        display: 'none'
      });
      $('.contact-us-bubble__close').css({
        opacity: 1
      });
    });
  };
  var handleOnHide = function handleOnHide() {
    $('.contact-us-bubble__close').css({
      opacity: 0
    });
    $('.contact-us-bubble').css({
      width: 130
    });
    setTimeout(function () {
      $('.contact-us-bubble__close').css({
        display: 'none'
      });
      $('.contact-us-bubble__label').css({
        display: 'flex'
      });
      $('.contact-us-bubble__label').css({
        opacity: 1
      });
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "contact-us-bubble",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-us-bubble__label"
  }, "Contact Us"), /*#__PURE__*/React.createElement("div", {
    className: "contact-us-bubble__close"
  }, /*#__PURE__*/React.createElement(FaTimes, null))), /*#__PURE__*/React.createElement(ContactUsPopup, {
    isOpen: isOpen
  }));
};
export default ContactUsBubble;